import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AdminAuthContextProvider } from './administrator/admin/AdminAuthContext';
import { EmployeeAuthContextProvider } from "./employee/EmployeeAuthContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

     <AdminAuthContextProvider>
       <EmployeeAuthContextProvider>
             <App />
       </EmployeeAuthContextProvider>    
     </AdminAuthContextProvider>
  </React.StrictMode>
);

